<div class="pv">
    @if (!readOnly && !loading && !error && pages.length) {
    <div class="pv-tools">
        @if (hasText) {
        <div class="pv-mode" role="group" aria-label="Pin mode">
            <button type="button" class="pv-mode-btn" [class.is-on]="mode === 'text'" (click)="setMode('text')">
                <mat-icon>text_fields</mat-icon> Select text
            </button>
            <button type="button" class="pv-mode-btn" [class.is-on]="mode === 'area'" (click)="setMode('area')">
                <mat-icon>crop_free</mat-icon> Draw area
            </button>
        </div>
        }
        <span class="pv-hint">
            <mat-icon>push_pin</mat-icon>
            {{ mode === 'text' ? 'Highlight words to pin a comment to them' : 'Drag a box over the material to pin a comment' }}
        </span>
    </div>
    }

    @if (paged && pages.length > 1) {
    <div class="pv-sheets-tabs" role="tablist">
        @for (page of pages; track $index) {
        <button type="button" role="tab" class="pv-sheet-tab" [class.is-on]="activePage === $index"
            [attr.aria-selected]="activePage === $index" (click)="showPage($index)">
            {{ page.label.replace('Sheet: ', '') }}
        </button>
        }
    </div>
    }

    @if (loading) {
    <div class="pv-state">
        <span class="pv-spinner" aria-hidden="true"></span>
        Loading {{ fileName }}…
    </div>
    }

    @if (error) {
    <div class="pv-state is-error">
        <mat-icon>error_outline</mat-icon>
        <p>{{ error }}</p>
        <a [href]="src" target="_blank" rel="noopener noreferrer">
            <mat-icon>open_in_new</mat-icon> Open file
        </a>
    </div>
    }

    <!-- Filled by the renderer; Angular owns nothing inside it. -->
    <div #host class="pv-host" [class.is-area]="mode === 'area' && !readOnly" [class.is-read-only]="readOnly"
        (pointerdown)="onPointerDown($event)" (pointermove)="onPointerMove($event)"
        (pointerup)="onPointerUp($event)" (mouseup)="onMouseUp()"></div>
</div>
